<div class="hstack gap-1">
  <lui-avatar
    *ngIf="props.iconPath"
    [color]="(entity | get : props.colorPath || '') || 'primary'"
    [size]="(entity | get : props.sizePath || '') || 48"
  >
    <mat-icon [svgIcon]="entity | get : props.iconPath"></mat-icon>
  </lui-avatar>
  <div class="d-flex flex-column">
    <span class="mat-body-strong">{{ entity | get : props.titlePath }}</span>
    <span>{{ entity | get : props.subtitlePath }}</span>
  </div>
</div>
